<template>
  <div class="custom-container" v-loading.fullscreen.lock="promo.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="6">
        <div class="promo-title">Duplicate Promo &#38; Voucher</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save">Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>

    <el-row v-if="!promo.isLoading">
      <el-col :span="24" class="ml-4">
        <el-form label-position="left" ref="promo" label-width :model="promo.data">
          <el-col :span="9">
            <h1 class="my-4">Promo Rule</h1>
            <Form :Promo="promo.data"></Form>
          </el-col>
          <el-col :span="3">
            <span>&nbsp;</span>
          </el-col>
          <el-col :span="8" class="mt-4">
            <FormPromo v-if="promo.data.promoType === 'promo_to_item'" :Promo="promo.data"></FormPromo>
            <FormStrata v-if="promo.data.promoType === 'strata_disc'" :Promo="promo.data"></FormStrata>
            <FormPaymentToCart
              v-if="promo.data.promoType === 'payment_method_to_cart'"
              :Promo="promo.data"
              :save="save"
            ></FormPaymentToCart>
            <FormPromoToCart
              v-else-if="promo.data.promoType === 'promo_to_cart'"
              :Promo="promo.data"
            ></FormPromoToCart>
            <FormVoucher v-else-if="promo.data.promoType === 'voucher'" :Promo="promo.data"></FormVoucher>
            <!-- <FormPushToCart v-else-if="promo.data.promoType === 'push_to_cart'" :Promo="promo.data"></FormPushToCart> -->
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
import FormPromo from "./Promo/index";
import FormPaymentToCart from "./PaymentToCart/index";
import FormPromoToCart from "./PromoToCart/index";
import FormStrata from "./Strata/index";
import FormVoucher from "./PromoToVoucher/index";
export default {
  props: ["promoType", 'id'],
  components: {
    Form,
    FormPromo,
    FormPaymentToCart,
    FormPromoToCart,
    FormStrata,
    FormVoucher
  },
  data: () => ({}),
  computed: {
    ...mapState({
      promo: state => state.promo.promo
    }),
  },
  methods: {
    ...mapActions({
      getPromo: "promo/GetPromo",
      createPromo: "promo/CreatePromo"
    }),
    /**
     * untuk hapus key object yang tidak dipilih
     */
    removeKeyOne(obj, letter, except) {
      Object.keys(obj).forEach(function (key) {
        if (key !== except) {
          if (key !== letter) delete obj[key];
        }
      });
    },
    /**
     * untuk hapus key object yang tidak dipilih
     */
    removeKeyMany(obj, letter, except) {
      Object.keys(obj).forEach(function (key) {
        if (key !== except) {
          if (!letter.includes(key)) delete obj[key];
        }
      });
    },
    save() {
      
      let target, promoValue, boundary;
      if (this?.promoType === 'payment_method_to_cart') {
        target = this.promo.data.promoTargetPaymentMethod.target;
        promoValue = this.promo.data.promoTargetPaymentMethod.promoValue;

        delete this.promo.data._id
        this.$refs.promo.validate(valid => {
        if (valid) {
          this.createPromo(this.promo.data);
          this.snackbar = true;
        } else {
          return false;
        }
        });
      } else if (this?.promoType === 'promo_to_cart') {
        target = this.promo.data.promoTargetCart.target;
        promoValue = this.promo.data.promoTargetCart.promoValue;
        boundary = this.promo.data.promoTargetCart.boundary;
        if (boundary.branch === '') {
          boundary.branch = null
        }

        delete this.promo.data._id
        this.$refs.promo.validate(valid => {
        if (valid) {
          this.createPromo(this.promo.data);
          this.snackbar = true;
        } else {
          return false;
        }
        });
      } else if (this?.promoType === 'promo_to_item') {
        target = this.promo.data.promoTargetItem.target;
        promoValue = this.promo.data.promoTargetItem.promoValue;
        boundary = this.promo.data.promoTargetItem.boundary;
        if (boundary.branch === '') {
          boundary.branch = null
        }
      } else if (this?.promoType === 'strata_disc') {
        target = this.promo.data.promoTargetStrata.target;
        promoValue = this.promo.data.promoTargetStrata.promoValue;
        boundary = this.promo.data.promoTargetStrata.boundary;
        if (boundary.branch === '') {
          boundary.branch = null
        }
      } else if (this?.promoType === 'voucher') {
        boundary = this.promo.data?.voucher.boundary;
        promoValue = this.promo.data?.voucher.promoValue;
        if (boundary.branch === '') {
          boundary.branch = null
        }      
        delete this.promo.data._id

          this.$refs.promo.validate(valid => {
          if (valid) {
            this.createPromo(this.promo.data);
            this.snackbar = true;
          } else {
            return false;
          }
        });
      }
      if (this?.promoType !== 'voucher') {
        this.removeKeyOne(target, target.targetType, "targetType");
      }
      this.removeKeyOne(
        promoValue,
        promoValue.promoValueType,
        "promoValueType"
      );
      if (this?.promoType !== 'payment_method_to_cart') {
        this.removeKeyMany(
          boundary,
          boundary.boundaryType,
          "boundaryType"
        );
      }
      delete this.promo.data._id
      if (this.promoType !== 'voucher') {
        this.createPromo(this.promo.data)
      }
      
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    const params = {
      promoType: this.promoType,
      id: this.id
    }
    this.getPromo(params);
  }
};
</script>

<style>
</style>
